export default __webpack_public_path__ + "static/media/banner2.bb5b57f0.png";